import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { FloorPlanState } from './floor-plan.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'floorPlan', resettable: true, idKey: 'id' })
export class FloorPlanStore extends EntityStore<FloorPlanState> {
  constructor() {
    super();
  }
}
